import { ScrollbarPlugin } from 'smooth-scrollbar';
import type { Data2d } from 'smooth-scrollbar/interfaces/data-2d';

export class LockScroll extends ScrollbarPlugin {
  public static pluginName = 'lock';

  public static defaultOptions = {
    isLock: false,
  };

  public onRender(remainMomentum: Data2d): { x: number; y: number } {
    if (this.options.isLock) {
      this.scrollbar.setMomentum(0, 0);
    } else {
      this.scrollbar.setMomentum(remainMomentum.x, remainMomentum.y);
    }
    return this.options.isLock ? { x: 0, y: 0 } : remainMomentum;
  }

  public transformDelta(delta: { x: number; y: number }): { x: number; y: number } {
    return this.options.isLock ? { x: 0, y: 0 } : delta;
  }
}

export class ScaleDeltaPlugin extends ScrollbarPlugin {
  public static pluginName = 'scaleDelta';

  public static defaultOptions = {
    isScaling: false,
    speed: 0.5,
  };

  public transformDelta(delta: Data2d): Data2d {
    if (this.options.isScaling) {
      return {
        x: delta.x * this.options.speed,
        y: delta.y * this.options.speed,
      };
    }
    return delta;
  }
}

export class EdgeEasingPlugin extends ScrollbarPlugin {
  public static pluginName = 'edgeEasing';

  private readonly _remainMomentum = {
    x: 0,
    y: 0,
  };

  public transformDelta(delta: Data2d): Data2d {
    const { limit, offset } = this.scrollbar;

    const x = this._remainMomentum.x + delta.x;
    const y = this._remainMomentum.y + delta.y;

    // clamps momentum within [-offset, limit - offset]
    this.scrollbar.setMomentum(
      Math.max(-offset.x, Math.min(x, limit.x - offset.x)),
      Math.max(-offset.y, Math.min(y, limit.y - offset.y)),
    );

    return { x: 0, y: 0 };
  }

  public onRender(remainMomentum: Data2d): void {
    Object.assign(this._remainMomentum, remainMomentum);
  }
}
